import { useState } from "react";
import InputFile from "../InputFile/InputFile";
import Style from "./InputImageStyle";

export const InputImage = ({ id, name, label, acceptedMimeTypes, alt, imageUrl = "",
  disabled = false, OnChange, OnRemove, image = {} as File }) => {
  const [isImageFilePicked, setIsImageFilePicked] = useState(false);
  const [deleted, setDeleted] = useState(false);
  function ChangeFileSelected(event) {
    setDeleted(false);
    const file = event.target.files[0];
    setIsImageFilePicked(file !== undefined);
    OnChange(event);
  };
  function onRemove() {
    setDeleted(true);
    if (OnRemove)
      OnRemove();
  }
  return (
    <Style>
      <div className="main">
        <div>
          <InputFile
            id={id}
            name={name}
            disabled={disabled}
            accept={acceptedMimeTypes}
            onChange={ChangeFileSelected}
          />
        </div>
        {(imageUrl || image.name) && (
          <div className="div-image">
            <div className="image">
              <img
                className={deleted ? "img-opacity" : ""}
                src={isImageFilePicked && image.name ? URL.createObjectURL(image) : imageUrl}
                alt={alt}
              />
              <div id="remove" onClick={() => onRemove()} >
                <p id="textRemove">Remover imagem</p>
              </div>
            </div>
          </div>
        )}
        {deleted && imageUrl && <label className="removeLabel" >Clique em editar para confirmar!</label>}
      </div>
    </Style>
  );
}
